
import { _replaceAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {}
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    _replaceAppConfig(newModule.default)
  })
}

import cfg0 from "/home/ivan/Dev/projects/BB/bigbang.hr/app.config.ts"
import cfg1 from "/home/ivan/Dev/projects/BB/bigbang-base/app.config.ts"
import cfg2 from "/home/ivan/Dev/projects/BB/nuxt-base/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, cfg1, cfg2, inlineConfig)
